import React from 'react';
import { Navigate } from 'react-router-dom';
import { useToast } from '../hooks/use-toast';

const AdminRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');
  const { toast } = useToast();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (userRole !== 'admin') {
    // Show toast notification
    setTimeout(() => {
      toast({
        title: 'Access Denied',
        description: 'Only admins can upload books.',
        variant: 'destructive',
      });
    }, 100);
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
